import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { Oauth2Service } from '@bytel/checkout';

import { MainCartService } from '@services/main-cart.service';

import { Observable, of } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';

import { TagService } from '../shared/tag/tag.service';
import { CustomerResolver } from './customer.resolver';
import { QuoteResolver } from './quote.resolver';
import { ReferrerResolver } from './referrer.resolver';
import { UserEligibiltyResolver } from './user-eligibility.resolver';

@Injectable({
    providedIn: 'root',
})
export class CheckoutResolver {
    private userEligibilityResolver: UserEligibiltyResolver = inject(UserEligibiltyResolver);
    private quoteResolver: QuoteResolver = inject(QuoteResolver);
    private customerResolver: CustomerResolver = inject(CustomerResolver);
    private oauth2Service: Oauth2Service = inject(Oauth2Service);
    private mainCartService: MainCartService = inject(MainCartService);
    private tagService: TagService = inject(TagService);
    private referrerResolver: ReferrerResolver = inject(ReferrerResolver);

    public resolve(route: ActivatedRouteSnapshot): Observable<any> {
        return this.oauth2Service.resolve(route).pipe(
            concatMap(() => this.tagService.initialize()),
            concatMap(() => this.referrerResolver.resolve()),
            concatMap(() => this.customerResolver.resolve()),
            concatMap(() => this.mainCartService.resolve()),
            concatMap(() => this.quoteResolver.resolve(route)),
            concatMap(() => this.userEligibilityResolver.resolve()),
            catchError((err) => {
                console.warn(err);
                return of(null);
            }),
            map(() => of(null)),
        );
    }
}
